import { connect } from 'react-redux';
import { IApplicationState } from '../../../../../types/types';
import { ISettingsPanelFields } from '../../containers/SettingsPanel/types';
import { SettingsPanel } from '../../containers/SettingsPanel/SettingsPanel';
import { getActiveBoardId } from '../../../../../store/model/selectors/getActiveBoardId';

const mapStateToProps = (
    state: IApplicationState,
): ISettingsPanelFields => {
    return {
        boardId: getActiveBoardId(state),
    }
};

export const SettingsPanelHOC = connect(
    mapStateToProps,
    null
)(SettingsPanel);

SettingsPanelHOC.displayName = 'SettingsPanelHOC';
